import CONSTANTS from '../constants'
import { EMPTY_ARRAY, EMPTY_OBJECT, } from '../../constants/globalConstants'

const INITIAL_STATE = {
    loader: false,
    hasError: false,
    facilty: EMPTY_ARRAY,
    rateList: EMPTY_OBJECT,
    proRateList: EMPTY_OBJECT,
    errorMessage: '',
    isModalOpen: false,
    permitPurchageClick: 0
}

const basicInfoReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        //RESPONSE HANDLING
        case CONSTANTS.GET_FACILITY_REQUEST:
            return {
                ...state,
                loader: true,
                errorMessage: ''
            }
        case CONSTANTS.GET_FACILITY_SUCCESS:
            return {
                ...state,
                loader: false,
                facilty: action.data,
                hasError: false,
                errorMessage: ''
            }
        case CONSTANTS.GET_FACILITY_FAILURE:
            return {
                ...state,
                loader: false,
                errorMessage: 'There is some Error'
            }

        // Rate List Constants
        case CONSTANTS.GET_PERMIT_RATE_LIST_REQUEST:
            return {
                ...state,
                loader: true,
                errorMessage: ''
            }
        case CONSTANTS.GET_PERMIT_RATE_LIST_SUCCESS:
            return {
                ...state,
                loader: false,
                rateList: action.data,
                hasError: false,
                errorMessage: ''
            }
        case CONSTANTS.GET_PERMIT_RATE_LIST_FAILURE:
            return {
                ...state,
                loader: false,
                errorMessage: 'There is some Error'
            }

        case CONSTANTS.OPEN_MODAL:
            return {
                ...state,
                isModalOpen: action.isModalOpen
            }
        case CONSTANTS.PERMIT_PURCHAGE_CLICK:
            return {
                ...state,
                permitPurchageClick: state.permitPurchageClick + 1
            }    
        default:
            return state
    }
}

export default basicInfoReducer
